

		<div id="owl-demo-2" class="owl-carousel owl-theme">
			<article class="thumbnail item" itemscope="" itemtype="http://schema.org/CreativeWork"
				*ngFor="let sector of sectores">
				<a class="blog-thumb-img" href="/5-ways-baby-boomers-changing-healthcare/" title="">
					<img src="assets/img/barrios/{{ sector.imageUrl }}" class="img-responsive" />
				</a>
				<div class="caption">
					<h4 itemprop="headline">
						<a href="#" rel="bookmark">{{sector.barrio}}</a>
					</h4>
					<p itemprop="text" class="flex-text text-muted">5 ways baby boomers are changing healthcare Starting
						in 2011, 3 million baby boomers each year reach retirement age....</p>
					<p><a class="btn btn-primary btn-block">Button Text</a></p>
				</div>
			</article>
		</div>

